
    import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
    import { StringUtil } from '../scripts/StringUtil';

@Component
export default class MoneyTextField extends Vue {
    //親コンポーネント設定値
    @Prop({ required: true }) value!: string;
    //ラベル表示名
    @Prop({ required: true }) label!: string;
    //活性制御
    @Prop({ default: false }) disabled!: boolean;

    //#region 変数
    formattedValue: string = StringUtil.formatNumber(this.value);
    errorMessages: string[] = [];
    //#endregion
    
    //#region イベント

    //#region テキスト　入力
    private onInput(value: string| null) {
        if (!value || value === '') {
            // 入力値が空の場合、エラーメッセージをクリアし、親コンポーネントにnullを渡す
            this.errorMessages = [];
            this.$emit('input', null);
            this.formattedValue = '';
        } else {
            const parsedValue = this.parseNumber(value);
            if (isNaN(Number(parsedValue))) {
                this.errorMessages = ['無効な入力値です'];
                this.$emit('input', null); // nullを親コンポーネントに渡す
            } else {
                this.errorMessages = [];
                this.$emit('input', parsedValue); // カンマを除去した数値を親コンポーネントに渡す
            }
            this.formattedValue = StringUtil.formatNumber(parsedValue);
        }
    }
    //#endregion

    //#region 親コンポーネント設定値 ウォッチャー
    @Watch('value')
    onValueChanged(newValue: string) {
        this.formattedValue = StringUtil.formatNumber(newValue);
        this.onInput(newValue);
      }
    //#endregion

    //#endregion

    //#region プライベートメソッド
    
    //#region 数値のみの値を返す
    private parseNumber(value: any): string {
        
        if (!value) {
            value = '';
            return value;
        } else {
            value = value.toString();
            let parsedValue = value.replace(/,/g, '').replace(/^0+/, '');
            return parsedValue === '' ? '0' : parsedValue;
        }
    }
    //#endregion

    //#endregion
}
